/*
 * Generated from Times-BoldItalic.afm. Do not edit directly.
 * The source AFM metrics were converted to JavaScript; this is a modification.
 * Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.
 *
 * This file and the 14 PostScript(R) AFM files it accompanies may be used, copied, and distributed for any purpose and without charge, with or without modification, provided that all copyright notices are retained; that the AFM files are not distributed without this file; that all modifications to this file or any of the AFM files are prominently noted in the modified file(s); and that this paragraph is not modified. Adobe Systems has no responsibility or obligation to support the use of the AFM files.
 */
import glyphNames from './standardGlyphNames.js';
export default {
  name: 'Times-BoldItalic',
  bbox: [-200, -218, 996, 921],
  ascender: 683,
  descender: -217,
  xHeight: 462,
  capHeight: 669,
  glyphNames,
  glyphWidths: [
    250, 389, 555, 500, 500, 833, 778, 278, 333, 333, 500, 570, 250, 333, 250,
    278, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 333, 333, 570, 570,
    570, 500, 832, 667, 667, 667, 722, 667, 667, 722, 778, 389, 500, 667, 611,
    889, 722, 722, 611, 722, 667, 556, 611, 722, 667, 889, 667, 611, 611, 333,
    278, 333, 570, 500, 333, 500, 500, 444, 500, 444, 333, 500, 556, 278, 278,
    500, 278, 778, 556, 500, 500, 500, 389, 389, 278, 556, 444, 667, 500, 444,
    389, 348, 220, 348, 570, 500, 333, 500, 500, 1000, 500, 500, 333, 1000, 556,
    333, 944, 611, 333, 333, 500, 500, 350, 500, 1000, 333, 1000, 389, 333, 722,
    389, 444, 389, 500, 500, 500, 500, 220, 500, 333, 747, 266, 500, 606, 747,
    333, 400, 570, 300, 300, 333, 576, 500, 250, 333, 300, 300, 500, 750, 750,
    750, 500, 667, 667, 667, 667, 667, 667, 944, 667, 667, 667, 667, 667, 389,
    389, 389, 389, 722, 722, 722, 722, 722, 722, 722, 570, 722, 722, 722, 722,
    722, 611, 611, 500, 500, 500, 500, 500, 500, 500, 722, 444, 444, 444, 444,
    444, 278, 278, 278, 278, 500, 556, 500, 500, 500, 500, 500, 570, 500, 556,
    556, 556, 556, 444, 500,
  ],
  kernPairs: [
    -129,
    [8182, 2, 2148, 2, 1288, 2],
    -111,
    [
      11675, 4, 10, 105, 1, 1, 1, 1, 1, 4, 1, 8, 1, 1, 1, 1, 2, 506, 10, 114, 9,
      1, 1, 1, 1, 2, 26521, 10, 114, 9, 1, 1, 1, 1, 2,
    ],
    -100,
    [
      7150, 1053, 36, 83, 1, 1, 1, 1, 1, 35, 1, 1, 1, 24370, 215, 215, 215, 215,
      215,
    ],
    -95,
    [
      2689, 2, 428, 2, 4028, 1086, 119, 1, 1, 1, 1, 1, 2900, 123, 1, 1, 1, 1, 2,
      21346, 215, 215, 215, 215, 215,
    ],
    -92,
    [
      11192, 1, 1, 51, 4, 115, 1, 1, 1, 1, 1, 4, 1, 893, 1, 13, 1, 38, 20, 99,
      1, 1, 1, 1, 1, 20, 1, 1, 1, 26460, 1, 13, 1, 38, 20, 99, 1, 1, 1, 1, 1,
      20, 1, 1, 1,
    ],
    -90,
    [11894, 124, 1],
    -85,
    [
      10353, 119, 1, 1, 1, 1, 1, 1166, 119, 1, 1, 1, 1, 1, 123, 119, 1, 1, 1, 1,
      1,
    ],
    -80,
    [11904, 123, 1, 1, 1, 1, 2],
    -74,
    [
      7181, 1, 2, 20, 12, 92, 3898, 1, 429, 1, 200, 2, 19, 119, 1, 1, 1, 1, 1,
      287, 19, 119, 1, 1, 1, 1, 1, 10916, 107, 83, 26, 8, 9214, 1, 2, 20, 12,
      92, 88, 1, 2, 20, 12, 92, 88, 1, 2, 20, 12, 92, 88, 1, 2, 20, 12, 92, 88,
      1, 2, 20, 12, 92, 88, 1, 2, 20, 12, 92, 4961, 19, 119, 1, 1, 1, 1, 1,
    ],
    -71,
    [11802, 3, 642, 2, 1, 26657, 2, 1],
    -70,
    [
      54, 1, 2, 124, 6971, 124, 973, 123, 1, 1, 1, 1, 2, 3245, 21114, 124, 91,
      124, 91, 124, 91, 124, 91, 124, 91, 124,
    ],
    -65,
    [
      7130, 124, 10388, 2, 15071, 124, 91, 124, 91, 124, 91, 124, 91, 124, 91,
      124,
    ],
    -60,
    [7134, 25585, 215, 215, 215, 215, 215],
    -55,
    [
      7144, 3, 2422, 830, 123, 1, 1, 1, 1, 2, 685, 119, 1, 1, 1, 1, 1, 346, 12,
      112, 12, 1, 1, 1, 29, 1, 58, 4, 32, 88, 1, 1, 1, 1, 290, 124, 20277, 3,
      212, 3, 212, 3, 212, 3, 212, 3, 212, 3, 5181, 124,
    ],
    -52,
    [11372, 3],
    -50,
    [
      7142, 6, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 519, 3, 124, 331, 1907, 1, 2,
      124, 103, 123, 1, 1, 1, 1323, 179, 3, 20707, 6, 117, 1, 1, 1, 1, 2, 1, 1,
      1, 1, 82, 6, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 82, 6, 117, 1, 1, 1, 1, 2, 1,
      1, 1, 1, 82, 6, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 82, 6, 117, 1, 1, 1, 1, 2,
      1, 1, 1, 1, 82, 6, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 2669, 1, 2, 124, 88, 1,
      2, 124, 88, 1, 2, 124, 88, 1, 2, 124, 88, 1, 2, 124, 303, 1, 2, 124,
    ],
    -45,
    [
      11428, 119, 1, 1, 1, 1, 1, 26536, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1,
      1, 91, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1,
    ],
    -40,
    [
      7795, 448, 123, 1, 1, 1, 726, 4, 10, 6, 99, 1, 1, 1, 1, 1, 3, 1, 1, 1, 7,
      1, 1, 1, 1, 2, 1, 1, 1, 1, 896, 19, 4, 96, 1, 1, 1, 1, 1, 123, 119, 1, 1,
      1, 1, 1, 288, 6, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 3274, 2652, 19727, 19, 4,
      96, 1, 1, 1, 1, 1, 91, 19, 4, 96, 1, 1, 1, 1, 1, 91, 19, 4, 96, 1, 1, 1,
      1, 1, 91, 19, 4, 96, 1, 1, 1, 1, 1, 91, 19, 4, 96, 1, 1, 1, 1, 1, 306, 19,
      4, 96, 1, 1, 1, 1, 1, 5304,
    ],
    -37,
    [
      33, 119, 1, 1, 1, 1, 1, 9357, 1, 2, 32, 32, 60, 32, 1580, 9, 3, 2, 2, 32,
      76, 12, 1, 1, 1, 1, 505, 124, 6480, 2, 213, 2, 428, 2, 4370, 2508, 2,
      19778, 2,
    ],
    -30,
    [
      7180, 124, 1, 1, 1, 1985, 123, 1, 1, 1, 1, 2, 502, 119, 1, 1, 1, 1, 1,
      755, 855, 123, 1, 1, 1, 1, 2, 4408, 123, 1, 1, 1, 16445, 124, 1, 1, 1, 88,
      124, 1, 1, 1, 88, 124, 1, 1, 1, 88, 124, 1, 1, 1, 88, 124, 1, 1, 1, 88,
      124, 1, 1, 1, 2401, 119, 1, 1, 1, 1, 1,
    ],
    -25,
    [
      7343, 119, 1, 1, 1, 1, 1, 306, 119, 1, 1, 1, 1, 1, 1166, 119, 1, 1, 1, 1,
      1, 127, 10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2, 2849, 123, 1, 1, 1, 1, 2,
      4641, 21890, 123, 1, 1, 1, 1, 2, 4426, 215, 215, 215, 215, 430,
    ],
    -20,
    [9330, 4, 32, 88, 1, 1, 1, 1, 4817, 124, 1, 1, 1],
    -18,
    [9512, 1292, 1, 2, 124, 296, 123, 1, 1, 1, 1, 2, 3764],
    -15,
    [
      11872, 123, 1, 1, 1, 1, 2, 5070, 1488, 10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2,
      86, 123, 1, 1, 1, 1, 2, 4590, 14, 4, 19995, 215, 215, 215, 215, 430,
    ],
    -10,
    [
      7363, 124, 1, 1, 1, 1552, 2, 1544, 124, 1, 1, 1, 934, 2607, 221, 3, 421,
      161, 2, 55, 10, 114, 9, 1, 1, 1, 3, 946, 123, 1, 1, 1, 1, 2, 740, 1, 32,
      92, 1572, 4, 115, 1, 1, 1, 1, 1, 3, 1, 1, 1, 89, 123, 1, 1, 1, 22022, 3,
      206, 215, 215, 215, 1527, 1, 32, 92, 90, 1, 32, 92, 90, 1, 32, 92, 90, 1,
      32, 92, 90, 1, 32, 92, 305, 1, 32, 92,
    ],
    55,
    [15159],
  ],
};
